import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-synchronize-modal',
  templateUrl: './synchronise-modal.component.html',
  styleUrls: ['./synchronise-modal.component.css']
})
export class SynchroniseModalComponent implements OnInit {

  @Output() closeEvent = new EventEmitter();
  @Output() syncWithSpotify = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  synchronise() {
    this.syncWithSpotify.emit();
  }

  cancel() {
    this.closeEvent.emit();
  }


}
